export default "__VITE_ASSET__CV$V45kM__"